module.exports = __webpack_public_path__ + "img/powerGrid-icon_1.163e9e07.png";